const Title = ({ title, subtitle }) => {
    return (
        <div className="main-list__info">
            <div className="main-list__title">
                {title}
            </div>
            <div className="main-list__description">{subtitle}</div>
        </div>
    );
};

export default Title;
